export default {
    GET_EXTENSIONS(state, value) {
        state.extensions=value
    },
    GET_SELECTED_EXTENSION(state, value) {
        state.selectedextension=value
    },
    TOTAL_EXTENSIONS(state, value) {
        state.totalextensions=value
    },
    CREATE_EXTENSIONS_ORDER(state, value) {
        state.extensionsorders=value
    },
    ADD_EXTENSIONS_REQUEST(state, value) {
        state.extensionsrequests=value
    },
    GET_EXTENSIONS_REQUEST(state, value) {
        state.getextensionsrequests=value
    },
}